import React, { useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const message = (location.state as any)?.message;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      const needsSetup = await login(username, password);
      if (needsSetup) {
        navigate('/admin/setup');
      } else {
        navigate('/admin');
      }
    } catch (err: any) {
      const detail = err.response?.data?.detail || 'Invalid username or password';
      setError(detail);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui',
      background: '#f5f5f5'
    }}>
      <form onSubmit={handleSubmit} style={{
        width: '350px',
        background: '#fff',
        padding: '32px',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ marginBottom: '24px', fontSize: '24px' }}>ConstMGR Admin</h1>

        {message && (
          <div style={{
            color: '#155724',
            background: '#d4edda',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            {message}
          </div>
        )}

        {error && (
          <div style={{
            color: '#dc3545',
            background: '#f8d7da',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
            Username
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: '100%', padding: '10px', boxSizing: 'border-box', fontSize: '16px' }}
            required
          />
        </div>

        <button
          type="submit"
          style={{
            width: '100%',
            padding: '12px',
            cursor: 'pointer',
            background: '#007bff',
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            fontSize: '16px',
            fontWeight: 'bold',
            marginBottom: '16px'
          }}
        >
          Login
        </button>

        <p style={{ textAlign: 'center', margin: 0 }}>
          Don't have an account?{' '}
          <Link to="/admin/register" style={{ color: '#007bff' }}>Register</Link>
        </p>
      </form>
    </div>
  );
}
